import { useTheme } from '@hover/blueprint';
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const DarkThemeColor = () => {
  const { colors } = useTheme();

  return (
    <Helmet>
      <meta content={colors.neutral['900']} name="theme-color" />
    </Helmet>
  );
};
